// extracted by mini-css-extract-plugin
export default {"trackStyle":"inputSlider_trackStyle__-Zuw1"};